module.exports = __webpack_public_path__ + "img/966034301.9fab8450.jpg";